import { useMemo } from 'react'
import TalkChannelPreview from './TalkChannelPreview'
import { Assets } from '../../Codes'
import { convertTalkChannelAssets } from '../creativeUtil'
import PropTypes from 'prop-types'

const MixedTalkChannelPreview = ({
  channel,
  creative: { licenseReviewYn, licenseNumber, assets, license },
}) => {
  const basic = useMemo(
    () => ({
      licenseReview: licenseReviewYn === 'Y',
      licenseNumber: licenseNumber || '',
      license: {
        recommendLicenseNumber: license?.recommendLicenseNumber || '',
        customLicenseNumber: license?.customLicenseNumber || '',
      },
    }),
    [licenseReviewYn, licenseNumber, license]
  )
  const { thumbnailRecommend, thumbnailCustom } = useMemo(
    () => convertTalkChannelAssets(assets),
    [assets]
  )
  return (
    <>
      <div className="view_detail view_mo">
        <em className="view_type">추천소재</em>
        <TalkChannelPreview
          channel={channel}
          basic={basic}
          type={Assets.THUMBNAIL_RECOMMEND.name}
          data={thumbnailRecommend}
        />
      </div>
      <div className="view_detail view_mo">
        <em className="view_type">맞춤소재</em>
        <TalkChannelPreview
          channel={channel}
          basic={basic}
          type={Assets.THUMBNAIL_CUSTOM.name}
          data={thumbnailCustom}
        />
      </div>
    </>
  )
}
export default MixedTalkChannelPreview
MixedTalkChannelPreview.propTypes = {
  channel: PropTypes.shape({
    name: PropTypes.string,
  }),
  creative: PropTypes.shape({
    licenseReviewYn: PropTypes.oneOf(['Y', 'N']),
    licenseNumber: PropTypes.string,
    license: PropTypes.shape({
      recommendLicenseNumber: PropTypes.string,
      customLicenseNumber: PropTypes.string,
    }),
    assets: PropTypes.array,
  }),
}
